import { batchActions } from 'redux-batched-actions';
// import { displayMessage } from 'state/actions/message_status';
// import { displayModal } from 'state/actions/modal_status';
import { isFormValid } from 'utils/shared_form_utils';
import {
    displayErrorMessage,
    displaySuccessMessage
} from 'utils/messages';


export const FORM_SET_FIELD_VALUE = 'FORM_SET_FIELD_VALUE';
export const FORM_SET_FIELD_VALIDATION = 'FORM_SET_FIELD_VALIDATION';
export const FORM_SET_EDITABLE_STATE = 'FORM_SET_EDITABLE_STATE';
export const FORM_DISCARD_CHANGES = 'FORM_DISCARD_CHANGES';
export const FORM_FETCHING_ERROR = 'FORM_FETCHING_ERROR';
export const FORM_SAVING_ERROR = 'FORM_SAVING_ERROR';
export const FORM_FETCH_IN_PROGRESS = 'FORM_FETCH_IN_PROGRESS';
export const FORM_SAVE_IN_PROGRESS = 'FORM_SAVE_IN_PROGRESS';
export const FORM_RECEIVE_DATA = 'FORM_RECEIVE_DATA';
export const FORM_SAVE_DATA = 'FORM_SAVE_DATA';
export const FORM_INVALIDATE_FIELDS = 'FORM_INVALIDATE_FIELDS';
export const FORM_RESET = 'FORM_RESET';
export const FORM_REPOPULATE = 'FORM_REPOPULATE';

export const setFormFieldValue = (formName, fieldName, value) => ({
    type: FORM_SET_FIELD_VALUE,
    formName,
    fieldName,
    value
});
export const setFieldValidation = (formName, fieldName, validationStatus) => ({
    type: FORM_SET_FIELD_VALIDATION,
    formName,
    fieldName,
    validationStatus
});
export const setFormEditableState = (formName, isEditable) => ({
    type: FORM_SET_EDITABLE_STATE,
    formName,
    isEditable
});
export const discardChanges = formName => ({
    type: FORM_DISCARD_CHANGES,
    formName
});
export const invalidateForm = formName => ({
    type: FORM_INVALIDATE_FIELDS,
    formName
});

// ACTION CREATORS FOR THUNKS
export const receiveFormData = (formName, formData) => ({
    type: FORM_RECEIVE_DATA,
    formName,
    formData
});
const saveFormData = (formName, formData) => ({
    type: FORM_SAVE_DATA,
    formName,
    formData
});
const formSaveingError = formName => ({
    type: FORM_SAVING_ERROR,
    formName
});
const formFetchingError = formName => ({
    type: FORM_FETCHING_ERROR,
    formName
});
const formFetchInProgerss = formName => ({
    type: FORM_FETCH_IN_PROGRESS,
    formName
});
const formSaveInProgress = formName => ({
    type: FORM_SAVE_IN_PROGRESS,
    formName
});
export const resetForm = formName => ({
    type: FORM_RESET,
    formName
});
const repopulateForm = formName => ({
    type: FORM_REPOPULATE,
    formName
});


// THUNK CREATORS
const isAuthForm = formName => !!['signin', 'completesignup', 'resetpassword', 'requestdemo', 'completepasswordreset'].includes(formName);
export const getFormData = (formName, fetchFormDataCallUtil, id) => dispatch => {
    dispatch(formFetchInProgerss(formName));
    return fetchFormDataCallUtil(id ? id : null)
        .then(response => dispatch(receiveFormData(formName, response.data)))
        .catch(() => dispatch(formFetchingErrorWithMessage(formName)))
};
const updateFormData = (formName, patchFormDataCallUtil, updatedFormData, id, successAction, failAction) => dispatch => {
    dispatch(formSaveInProgress(formName));
    return patchFormDataCallUtil(updatedFormData, formName, id)
        .then(response =>{
            dispatch(batchActions([
                saveFormData(formName, response.data),
                formSavedSuccessMessage(formName)
            ]));
            if(successAction)successAction(response)
        })
        .catch(error =>{
            dispatch(formSavingErrorWithMessage(formName));
            if(failAction)failAction(error.response);
        })
};
const createFormData = (formName, postFormDataCallUtil, formDataToSave, successAction, failAction) => dispatch =>  {
    dispatch(formSaveInProgress(formName));
    return postFormDataCallUtil(formDataToSave)
        .then(response => {
            //we are not firing success messages when signing up or signing in, only on fail
            if(!isAuthForm(formName)) dispatch(batchActions([saveFormData(formName, response.data), formSavedSuccessMessage(formName)]));
            if(successAction) successAction(response)
        }, error => {
            if(!isAuthForm(formName)) dispatch(formSavingErrorWithMessage(formName, error.response));
            if(failAction) failAction(error.response)
        })
};

export const getFormDataOrRepopulate = (formName, fetchFormDataCallUtil, hasStoredData, id) => (
    hasStoredData ? repopulateForm(formName) : getFormData(formName, fetchFormDataCallUtil, id)
);


export const updateFormDataWithValidation = (formName, fields, patchFormDataCallUtil, updatedFormData, id, successAction, failAction) => (
    isFormValid(fields) ? updateFormData(formName, patchFormDataCallUtil, updatedFormData, id, successAction, failAction) : invalidateForm(formName)
);


export const createFormDataWithValidation = (formName, fields, patchFormDataCallUtil, updatedFormData, successAction, failAction) => (
    isFormValid(fields) ? createFormData(formName, patchFormDataCallUtil, updatedFormData, successAction, failAction) : invalidateForm(formName)
);

const formFetchingErrorWithMessage = formName => batchActions([
    formFetchingError(formName),
    displayErrorMessage(getFormFetchErrorMessageText(formName))
]);

const formSavingErrorWithMessage = (formName, errorResponse) => batchActions([
    formSaveingError(formName),
    displayErrorMessage(getFormSaveMessageText(formName, false, errorResponse))
]);

const formSavedSuccessMessage = formName =>
    displaySuccessMessage(getFormSaveMessageText(formName, true, null));


//-=-=-= HELPERS TO SELECT MESSAGES DYNAMICALLY -=-=-=-=//

const getFormSaveMessageText = (formName, success, response) =>{

    switch (formName) {
        case 'generalInformation':
            return success ? 'Your General information has been saved Successfully' : 'There was a problem saving your General Information';
        case 'editUser':
            return success ? 'You have successfully updated this users information' : 'There was a problem updating this users information';
        case 'addUser':
            return success ? 'User has been added successfully' : 'There was an issue adding this User';
        case 'WIRE':
            return success ? 'You have saved your wire transfer information' : 'There was an issue updating your wire transfer information';
        case 'PAYPAL':
            return success ? 'Your Paypal information has been saved' : 'There was an issue saving your paypal data';
        case 'CHECKS':
            return success ? 'Check information updated Successfully' : 'We could not process your check information';
        case 'ACH':
            return success ? 'We saved your direct deposit information!!!' : 'Please check your network, we could not process your direct deposit form';
        case 'completesignup':
            return success ? 'Your account has been created!' : 'We were unable to create your account';
        case 'personalInformationForm':
            return success ? 'Your profile information has been saved successfully' : 'There was a problem saving your profile information';
        default:
            return success ? 'Your information has been saved successfully' : 'Woops, something wrong. Please try again later.';
    }
};

const getFormFetchErrorMessageText = (formName, response=null) =>{
    switch (formName) {
        case 'generalInformation':
            return 'There was a problem fetching your General Information';
        case 'editUser':
            return 'There was a problem fetching this users information';
        case 'addUser':
            return 'There was an issue fetching this User';
        case 'WIRE':
            return 'There was an issue fetching your wire transfer information';
        case 'PAYPAL':
            return 'There was an issue fetching your paypal data';
        case 'CHECKS':
            return 'We could not fetch your check information';
        case 'ACH':
            return 'Please check your network, we could not fetch your direct deposit form';
        default:
            return 'Woops, something wrong: Network error. Please try again later.';
    }
};
